$(document).ready(function(){

	$('[data-component="opportunities-item"] .btn').on('mouseenter', function(){
		$('[data-component="opportunities-item"] .btn i').attr('class', 'icon-arrow-right-white');
	}).on('mouseleave', function(){
		$('[data-component="opportunities-item"] .btn i').attr('class', 'icon-arrow-right');
	})

});